import { ReactElement } from 'react';

import { BackgroundChatIndisponibleTitre, CardContactDescription, CardContactTitreIcon, Icon } from '@/components/Dico';

import styles from './styles.module.css';

type Props = {
  icon: keyof typeof Icon;
  textIcon: keyof typeof CardContactTitreIcon;
  textDescription: ReactElement;
  descriptionSection: keyof typeof CardContactDescription;
  buttonChat: ReactElement;
  backgroundTitre: keyof typeof BackgroundChatIndisponibleTitre;
};

const CardContact = ({ icon, textIcon, textDescription, descriptionSection, backgroundTitre, buttonChat }: Props) => {
  return (
    <div className={styles.boxCard}>
      <div className={styles.cardBody}>
        <div className={styles.iconTextBlock}>
          <div className={styles.iconBlock}>
            {Icon[icon]}
            <div className={styles.textIcon}>{CardContactTitreIcon[textIcon]}</div>
          </div>
          <div className={styles.textMiddle}>
            <div className={styles.titleSection}>
              <span className={styles[BackgroundChatIndisponibleTitre[backgroundTitre]]}>{textDescription}</span>
            </div>
            <div className={styles.descriptionSection}>
              <span className={styles.descriptionSectionColor}>{CardContactDescription[descriptionSection]}</span>
            </div>
          </div>
        </div>
        <div>{buttonChat}</div>
      </div>
    </div>
  );
};

export default CardContact;
